import { Form } from 'informed';
import styled, { css } from 'styled-components';

import { Button } from '@nw/omega-design-system';

export const PaymentServiceModalHeading = styled.div`
  font-family: Inter;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #334155;
`;

export const PaymentServiceModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const fieldWrapperStyles = css`
  margin-bottom: 0;
`;

export const ContinueToPayButton = styled(Button)`
  border: none !important;
  border-radius: 8px !important;
  font-family: Inter !important;
  font-weight: 500 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  color: #ffffff !important;
  cursor: pointer !important;
  padding: 12px 16px !important;
  > svg {
    color: #ffffff !important;
  }
  &:disabled {
    background-color: #e2e8f0 !important;
    color: #64748b !important;
    cursor: not-allowed !important;
  }
`;

export const CancelPaymentInfo = styled('span')`
  font-family: 'Inter';
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.75;
  letter-spacing: 0.2px;
  color: #7b8794;
  margin-bottom: 36px;
  text-align: center;
`;

export const PaymentServiceForm = styled(Form)``;
